// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar-preferences {
    overflow-y: hidden;
    overflow-x: hidden;
    color: #ddd;
    font-family: Tahoma, Arial;
    font-size: 12px;
    text-shadow: 0 1px #232323;
    background: #363636;
}

.bar-preferences .panelbar {
    background: #363636;
}
.bar-preferences > div {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
}

.bar-preferences .search_results {
    color: white;
}

.bar-preferences .header {
    padding: 8px 15px 8px 15px;
    font-size: 14px;
    color: #dddddd;
    border-bottom: 1px solid #232323;
    background-color: #313131;
    margin: 0
}

.bar-preferences .tbsimple {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.5);
    height: 15px;
    color: #cccccc;
    padding: 3px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border-radius: 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
}

.bar-preferences .tbsimpleFocus {
    border: 1px solid rgba(0, 0, 0, 0.8);
    box-shadow: none;
}

.preferenceItem {
    padding: 2px 2px 2px 16px;
    position: relative;
    overflow: visible;
    color: #333;
}

.bar-preferences .label, .bar-preferences .preferenceItem span {
    color: #999999;
    font-size: 12px;
    text-overflow: ellipsis;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    top: 0;
    font-family: Tahoma, Arial;
    cursor: default;
    padding: 1px 3px 2px 7px;
    position: relative;
    overflow: visible;
    display: inline-block;
    line-height: 13px;
    white-space: nowrap;
    width: 300px;
}

.spinner {
    display: inline-block;
    height: 19px;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.1);
    min-height: 18px;
    max-height: 18px;
    text-align: right;
}

.spinnerFocus {
    border: 1px solid rgba(0, 0, 0, 0.8);
    box-shadow: 0;
}

.spinner input {
    outline: none;
    border-right: 0;
    padding: 1px 1px 2px 0;
    text-align: right;
    left: 0;
    height: 14px;
    color: #cccccc;
    font-family: Tahoma, Arial;
    font-size: 11px;
    margin: 0;
    z-index: 10000;
    border: 0;
    background: transparent;
}

::-webkit-scrollbar {
    background: none;
    width: 16px;
    height: 16px;
}

::-webkit-scrollbar-thumb {
    border: solid 0 rgba(0, 0, 0, 0);
    border-right-width: 4px;
    border-left-width: 4px;
    -webkit-border-radius: 9px 4px;
    -webkit-box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.2), inset 0 0 0 4px rgba(128, 128, 128, 0.2);
}

::-webkit-scrollbar-track-piece {
    margin: 4px 0;
}

::-webkit-scrollbar-thumb:horizontal {
    border-right-width: 0;
    border-left-width: 0;
    border-top-width: 4px;
    border-bottom-width: 4px;
    -webkit-border-radius: 4px 9px;
}

::-webkit-scrollbar-thumb:hover {
    -webkit-box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.9), inset 0 0 0 4px rgba(128, 128, 128, 0.9);
}

::-webkit-scrollbar-corner {
    background: transparent;
}

.ace_scrollbar-h {
    margin: 0 2px
}`, "",{"version":3,"sources":["webpack://./packages/demo/preferences/preferences.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,yBAAyB;IACzB;AACJ;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,mCAAmC;IACnC,kCAAkC;IAClC,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mCAAmC;IACnC,kCAAkC;IAClC,MAAM;IACN,0BAA0B;IAC1B,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,OAAO;IACP,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,SAAS;IACT,cAAc;IACd,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,sGAAsG;AAC1G;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,sGAAsG;AAC1G;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;AACJ","sourcesContent":[".bar-preferences {\n    overflow-y: hidden;\n    overflow-x: hidden;\n    color: #ddd;\n    font-family: Tahoma, Arial;\n    font-size: 12px;\n    text-shadow: 0 1px #232323;\n    background: #363636;\n}\n\n.bar-preferences .panelbar {\n    background: #363636;\n}\n.bar-preferences > div {\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 12px;\n}\n\n.bar-preferences .search_results {\n    color: white;\n}\n\n.bar-preferences .header {\n    padding: 8px 15px 8px 15px;\n    font-size: 14px;\n    color: #dddddd;\n    border-bottom: 1px solid #232323;\n    background-color: #313131;\n    margin: 0\n}\n\n.bar-preferences .tbsimple {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.5);\n    height: 15px;\n    color: #cccccc;\n    padding: 3px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    border-radius: 0;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 12px;\n}\n\n.bar-preferences .tbsimpleFocus {\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    box-shadow: none;\n}\n\n.preferenceItem {\n    padding: 2px 2px 2px 16px;\n    position: relative;\n    overflow: visible;\n    color: #333;\n}\n\n.bar-preferences .label, .bar-preferences .preferenceItem span {\n    color: #999999;\n    font-size: 12px;\n    text-overflow: ellipsis;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    top: 0;\n    font-family: Tahoma, Arial;\n    cursor: default;\n    padding: 1px 3px 2px 7px;\n    position: relative;\n    overflow: visible;\n    display: inline-block;\n    line-height: 13px;\n    white-space: nowrap;\n    width: 300px;\n}\n\n.spinner {\n    display: inline-block;\n    height: 19px;\n    margin: 0;\n    padding: 0;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n    background: rgba(255, 255, 255, 0.1);\n    min-height: 18px;\n    max-height: 18px;\n    text-align: right;\n}\n\n.spinnerFocus {\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    box-shadow: 0;\n}\n\n.spinner input {\n    outline: none;\n    border-right: 0;\n    padding: 1px 1px 2px 0;\n    text-align: right;\n    left: 0;\n    height: 14px;\n    color: #cccccc;\n    font-family: Tahoma, Arial;\n    font-size: 11px;\n    margin: 0;\n    z-index: 10000;\n    border: 0;\n    background: transparent;\n}\n\n::-webkit-scrollbar {\n    background: none;\n    width: 16px;\n    height: 16px;\n}\n\n::-webkit-scrollbar-thumb {\n    border: solid 0 rgba(0, 0, 0, 0);\n    border-right-width: 4px;\n    border-left-width: 4px;\n    -webkit-border-radius: 9px 4px;\n    -webkit-box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.2), inset 0 0 0 4px rgba(128, 128, 128, 0.2);\n}\n\n::-webkit-scrollbar-track-piece {\n    margin: 4px 0;\n}\n\n::-webkit-scrollbar-thumb:horizontal {\n    border-right-width: 0;\n    border-left-width: 0;\n    border-top-width: 4px;\n    border-bottom-width: 4px;\n    -webkit-border-radius: 4px 9px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    -webkit-box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.9), inset 0 0 0 4px rgba(128, 128, 128, 0.9);\n}\n\n::-webkit-scrollbar-corner {\n    background: transparent;\n}\n\n.ace_scrollbar-h {\n    margin: 0 2px\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
